import React from 'react';

import { PillarOneSliderScoreWorkspace } from './PillarOneSliderDirectionWorkspace';
import type { PillarOneSliderWorkspaceProps } from './PillarOneSliderDirectionWorkspace';

const PillarOneSliderMagnitudeWorkspace: React.FC<
  PillarOneSliderWorkspaceProps
> = props => <PillarOneSliderScoreWorkspace {...props} mode="magnitude" />;

export default PillarOneSliderMagnitudeWorkspace;
